import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaTabelaPrecoFormComponent } from './campanha-tabela-preco-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaTabelaPrecoFormComponent
    ],
    exports: [
        CampanhaTabelaPrecoFormComponent
    ]
})
export class CampanhaTabelaPrecoFormModule { }
